import axiosClient from './axiosClient'

const activityApi = {
  create: (boardId, params) => axiosClient.post(`boards/${boardId}/activity`, params),
  getOne: (boardId, taskId) => axiosClient.get(`boards/${boardId}/activity/${taskId}`),
}

export default activityApi